export default {
  statusColorNotDone: {
    color: '#aaa'
  },
  statusColorStarted: {
    color: '#00B8D4'
  },
  statusColorDone: {
    color: '#8BC34A'
  }
}



// WEBPACK FOOTER //
// ./src/helpers/colors.js